import { useFocusEffect, useNavigation } from "expo-router";
import { useCallback } from "react";

/**
 * Nested child stack hides its own header. Apply the title on the parent stack
 * whenever this screen is focused so it restores after a nested push (e.g. leave days).
 */
export function useParentStackTitle(title: string | undefined) {
    const navigation = useNavigation();

    useFocusEffect(
        useCallback(() => {
            if (!title) {
                return;
            }
            navigation.getParent()?.setOptions({ title });
        }, [title, navigation]),
    );
}
